// removed by extract-text-webpack-plugin
module.exports = {"container":"_2MJNm","stories-list":"_1fpaC","story":"_3GXVh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AlternativeProjects/AlternativeProjects.scss
// module id = ./src/components/AlternativeProjects/AlternativeProjects.scss
// module chunks = 4